/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface EventLog
 */
export interface EventLog {
  /**
   * If the event has an associated campaign
   * @type {string | null}
   * @memberof EventLog
   */
  campaignId?: string | null;
  /**
   *
   * @type {number}
   * @memberof EventLog
   */
  companyId: number;
  /**
   *
   * @type {number}
   * @memberof EventLog
   */
  dateCreated?: number;
  /**
   *
   * @type {string}
   * @memberof EventLog
   */
  dateCreatedIso?: string;
  /**
   *
   * @type {number}
   * @memberof EventLog
   */
  dateModified?: number;
  /**
   *
   * @type {string}
   * @memberof EventLog
   */
  dateModifiedIso?: string;
  /**
   * Relevant free-form json dict to associate with the event
   * @type {object}
   * @memberof EventLog
   */
  details?: object;
  /**
   * Unique id auto-generated for this entity
   * @type {string}
   * @memberof EventLog
   */
  eventId?: string;
  /**
   *
   * @type {string}
   * @memberof EventLog
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof EventLog
   */
  key: string;
  /**
   * The user-facing message your want to show
   * @type {string | null}
   * @memberof EventLog
   */
  message?: string | null;
  /**
   * Follow the same severity you wanter logged
   * @type {string}
   * @memberof EventLog
   */
  severity?: EventLogSeverityEnum;
  /**
   * Subject of the event
   * @type {object}
   * @memberof EventLog
   */
  subject?: object;
  /**
   *
   * @type {string | null}
   * @memberof EventLog
   */
  subjectId?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof EventLog
   */
  subjectType?: string | null;
  /**
   *
   * @type {Array<any>}
   * @memberof EventLog
   */
  tags?: Array<any>;
}

/**
 * @export
 */
export const EventLogSeverityEnum = {
  Info: 'info',
  Warn: 'warn',
  Error: 'error',
} as const;
export type EventLogSeverityEnum =
  (typeof EventLogSeverityEnum)[keyof typeof EventLogSeverityEnum];

/**
 * Check if a given object implements the EventLog interface.
 */
export function instanceOfEventLog(value: object): value is EventLog {
  if (!('companyId' in value) || value['companyId'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('key' in value) || value['key'] === undefined) return false;
  return true;
}

export function EventLogFromJSON(json: any): EventLog {
  return EventLogFromJSONTyped(json, false);
}

export function EventLogFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EventLog {
  if (json == null) {
    return json;
  }
  return {
    campaignId: json['campaign_id'] == null ? undefined : json['campaign_id'],
    companyId: json['company_id'],
    dateCreated:
      json['date_created'] == null ? undefined : json['date_created'],
    dateCreatedIso:
      json['date_created_iso'] == null ? undefined : json['date_created_iso'],
    dateModified:
      json['date_modified'] == null ? undefined : json['date_modified'],
    dateModifiedIso:
      json['date_modified_iso'] == null ? undefined : json['date_modified_iso'],
    details: json['details'] == null ? undefined : json['details'],
    eventId: json['event_id'] == null ? undefined : json['event_id'],
    id: json['id'],
    key: json['key'],
    message: json['message'] == null ? undefined : json['message'],
    severity: json['severity'] == null ? undefined : json['severity'],
    subject: json['subject'] == null ? undefined : json['subject'],
    subjectId: json['subject_id'] == null ? undefined : json['subject_id'],
    subjectType:
      json['subject_type'] == null ? undefined : json['subject_type'],
    tags: json['tags'] == null ? undefined : json['tags'],
  };
}

export function EventLogToJSON(value?: EventLog | null): any {
  if (value == null) {
    return value;
  }
  return {
    campaign_id: value['campaignId'],
    company_id: value['companyId'],
    date_created: value['dateCreated'],
    date_created_iso: value['dateCreatedIso'],
    date_modified: value['dateModified'],
    date_modified_iso: value['dateModifiedIso'],
    details: value['details'],
    event_id: value['eventId'],
    id: value['id'],
    key: value['key'],
    message: value['message'],
    severity: value['severity'],
    subject: value['subject'],
    subject_id: value['subjectId'],
    subject_type: value['subjectType'],
    tags: value['tags'],
  };
}
